import * as React from "react";

import { forceRefreshTokens } from "../auth";

export const SessionRefreshListener = () => {
  React.useEffect(() => {
    let interval: NodeJS.Timeout | null;

    const refreshSession = async () => {
      const refresh = async () => {
        try {
          await forceRefreshTokens();
          console.debug("Tokens refreshed successfully");
        } catch (error) {
          console.error("Failed to refresh session:", error);
        }
      };

      // Same intervals as main frontend
      const refreshInterval = 4 * 60 * 1000;

      if (document.visibilityState === "visible") {
        // Immediately refresh when page becomes visible
        await refresh();

        // Set up periodic refresh
        interval = setInterval(async () => {
          await refresh();
        }, refreshInterval);
      } else {
        // Clear interval when page becomes hidden
        if (interval) {
          clearInterval(interval);
          interval = null;
        }
      }
    };

    // Listen for visibility changes
    window.addEventListener("visibilitychange", refreshSession);

    // Initial refresh if page is already visible
    if (document.visibilityState === "visible") {
      refreshSession();
    }

    return () => {
      window.removeEventListener("visibilitychange", refreshSession);
      if (interval) {
        clearInterval(interval);
        interval = null;
      }
    };
  }, []);

  return null;
};
